<template>
    <div>
        <div class="event-handling-container">
            <!-- 标题区域 - 单独一行 -->
            <div class="event-title">
                财务报表
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props: [],
        data() {
            return {
                activeIndex: 1,
                options: [
                    // { name: '安阳城垣物业', colorClass: 'orange-dot' },
                ]
            };
        },
        created() {},
        methods: {
            handleOptionClick(index) {
                this.activeIndex = index;
            }
        }
    }
</script>
<style scoped>
    .event-handling-container {
        display: flex;
        flex-direction: column;
        /* 垂直排列：标题 + 内容 */
        /* width: 1550px; */
        height: 850px;
        background-color: rgba(2, 92, 96, 0.2);
        border-radius: 4px;
    }

    /* 标题样式 - 渐变背景 */
    .event-title {
        width: 400px;
        padding: 16px 20px;
        font-size: 18px;
        font-weight: bold;
        color: #ffffff;
        background-image: linear-gradient(135deg, #016565, #0a2442);
        clip-path: polygon(0 0, 70% 0%, 100% 100%, 0 100%);
        flex-shrink: 0;
        /* 防止被压缩 */
    }

    .content-wrapper {
        display: flex;
        flex: 1;
        overflow: hidden;
    }

    .options-list {
        width: 240px;
        padding: 10px;
    }

    .event-list-wrapper {
        flex: 1;
        padding: 10px;
        overflow: hidden;
    }

    /* 选项项基础样式 */
    .option-item {
        display: flex;
        align-items: center;
        padding: 12px 15px;
        margin-bottom: 8px;
        color: #ffffff;
        border: 1px solid transparent;
        border-radius: 4px;
        cursor: pointer;
        transition: all 0.3s ease;
    }


    /* 圆点样式 */
    .blue-dot {
        display: inline-block;
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background-color: #00ccff;
        margin-right: 10px;
    }

    .orange-dot {
        display: inline-block;
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background-color: #ff9933;
        margin-right: 10px;
    }

    .option-text {
        flex: 1;
    }

    /* 箭头图标样式 */
    .el-icon-arrow-right {
        color: #00cccc;
        font-size: 16px;
    }
</style>
